/**
 * @description Hold the previous bool/enum value until 1ms before a change so Highcharts
 * draws a vertical step instead of a diagonal interpolation.
 * @param {Array<Array<*>>} data Time-ordered [ts, val] pairs
 * @returns {Array<Array<*>>}
 */
export function insertBoolStepHolds(data) {
	if (!Array.isArray(data) || data.length < 2) {
		return data;
	}
	const out = [];
	for (let i = 0; i < data.length; i++) {
		const cur = data[i];
		if (i > 0) {
			const prev = out[out.length - 1];
			if (prev && prev[1] !== cur[1] && cur[0] > prev[0]) {
				const holdTs = cur[0] - 1;
				if (holdTs > prev[0]) {
					out.push([holdTs, prev[1]]);
				}
			}
		}
		out.push(cur);
	}
	return out;
}
